import React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgSurface = (
    {
        color = '#6254D7',
        width = 30,
        height = 30
    }: IconsModel
) => (
     <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30">
        <g fill="none" fillRule="evenodd">
            <g fill={color}>
                <g>
                    <g>
                        <g>
                            <path d="M6.971 4.983c.258-.258.667-.258.924 0L9.873 6.96c.258.258.258.667 0 .925-.129.129-.3.193-.473.193-.172 0-.344-.064-.473-.193l-.86-.86V21.9h14.897l-.86-.86c-.257-.257-.257-.666 0-.924.258-.258.667-.258.925 0l1.978 1.978c.257.258.257.666 0 .946l-1.978 1.977c-.13.13-.301.194-.473.194s-.344-.065-.473-.194c-.258-.258-.258-.666 0-.924l.86-.86H7.444c-.365 0-.666-.3-.666-.666V7.025l-.86.86c-.258.258-.667.258-.925 0-.257-.258-.257-.667 0-.925zm12.296 5.051c.365 0 .666.301.666.667v7.33c0 .365-.3.666-.666.666h-7.33c-.366 0-.667-.3-.667-.666v-7.33c0-.366.301-.667.667-.667zm4.514 6.406c.366 0 .667.28.667.667v.666c0 .365-.301.666-.667.666-.365 0-.666-.3-.666-.666v-.666c0-.366.3-.667.666-.667zm0-3.783c.366 0 .667.3.667.666v1.075c0 .366-.301.666-.667.666-.365 0-.666-.3-.666-.666v-1.075c0-.365.3-.666.666-.666zm0-3.783c.366 0 .667.3.667.666v1.075c0 .365-.301.666-.667.666-.365 0-.666-.3-.666-.666V9.54c0-.366.3-.666.666-.666zm0-3.354c.366 0 .667.301.667.667v.666c0 .365-.301.666-.667.666-.365 0-.666-.3-.666-.666-.344 0-.667-.301-.667-.666 0-.366.301-.667.667-.667zm-10.898 0c.365 0 .666.301.666.667 0 .365-.3.666-.666.666h-.667c-.365 0-.666-.301-.666-.666 0-.366.3-.667.666-.667zm3.761 0c.366 0 .667.301.667.667 0 .365-.301.666-.667.666H15.57c-.366 0-.667-.301-.667-.666 0-.366.301-.667.667-.667zm3.784 0c.365 0 .666.301.666.667 0 .365-.3.666-.666.666h-1.075c-.365 0-.666-.301-.666-.666 0-.366.3-.667.666-.667z" transform="translate(-368 -1030) translate(165 370) translate(0 541) translate(203 119)"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default SvgSurface
